var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right"},[_c('div',{staticClass:"datatitle"},[_vm._v(" "+_vm._s(_vm.mine_admin.title)+" ")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.mine_admin.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }